import React from 'react';
import TextField from 'material-ui/TextField';
import Typography from 'material-ui/Typography';
import SimpleEditor from '../../../components/editor/simple_editor';

export class PageHeadings extends React.Component {
    render() {
        let {
            title,
            updateTitleField,
            subheading,
            updateSubheadingField,
            oldUrl,
            updateOldUrlField,
            breadcrumbTitle,
            updateBreadcrumbTitleField,
            menuTitle,
            updateMenuTitleField,
            validateField,
            metaError,
        } = this.props;

        return (
            <div>
                <TextField
                    autoFocus
                    margin="dense"
                    id="title"
                    name="title"
                    label="H1"
                    value={title || ''}
                    onChange={(event) => {
                        updateTitleField(event.target.value);
                        validateField(event.target.value, event.target.name);
                    }}
                    error={metaError['title'] || title.length < 1}
                    helperText={
                        metaError['title'] || title.length < 1
                            ? 'Please fill in the content for H1!'
                            : 'Type H1 here'
                    }
                    fullWidth
                    required
                />
                <Typography variant="caption" className="typographyMargins">
                    Subheading
                </Typography>
                <SimpleEditor
                    initialValue={subheading || ''}
                    onChange={(htmlBody) => {
                        updateSubheadingField(htmlBody);
                    }}
                />
                <TextField
                    autoFocus
                    margin="dense"
                    id="breadcrumb_title"
                    name="breadcrumbTitle"
                    label="Breadcrumb Title"
                    value={breadcrumbTitle || ''}
                    onChange={(event) => {
                        updateBreadcrumbTitleField(event.target.value);
                        validateField(event.target.value, event.target.name);
                    }}
                    error={
                        metaError['breadcrumbTitle'] ||
                        breadcrumbTitle.length < 1
                    }
                    helperText={
                        metaError['breadcrumbTitle'] ||
                        breadcrumbTitle.length < 1
                            ? 'Please fill in the content for Breadcrumb Title!'
                            : 'Type Breadcrumb Title here'
                    }
                    fullWidth
                    required
                />
                <TextField
                    autoFocus
                    margin="dense"
                    id="menu_title"
                    label="Menu Title"
                    value={menuTitle || ''}
                    onChange={(event) => {
                        updateMenuTitleField(event.target.value);
                    }}
                    fullWidth
                />
                <TextField
                    autoFocus
                    margin="dense"
                    id="old_url"
                    label="Old Url"
                    value={oldUrl || ''}
                    onChange={(event) => {
                        updateOldUrlField(event.target.value);
                    }}
                    fullWidth
                />
            </div>
        );
    }
}

export default PageHeadings;



// WEBPACK FOOTER //
// ./src/containers/builder/form/meta_page_headings.js